<template>
  <div></div>
</template>

<script>
import { cache } from "@/utils/common";
export default {
  name: "home",
  components: {},
  created() {},
  mounted() {
    cache.set("isPay", this.$route.query.isPay);
    setTimeout(() => {
      this.$router.back();
    }, 500);
  },
};
</script>
